import React, { Component } from 'react';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import messages from './JobOfferArticleView.intl';

//styles
import styles from './JobOfferArticleView.module.scss';

import JobOffersStore from 'stores/JobOffers.store';
import ContentStore from 'stores/Content.store';
import { Container, Title } from 'common/components/Layout/Layout';
import PrimaryButton from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';
import JobOfferArticle from './components/Article/JobOfferArticle/JobOfferArticle';
import BigBlueBox from './components/BigBlueBox/BigBlueBox';
import JobOffersList from 'common/components/JobOffersList/JobOffersList';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import { EXTERNAL_LINK } from 'common/consts/common';
import { ANCHOR } from 'common/consts/common';

import Placeholder from 'common/components/Placeholder/Placeholder';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

import LanguageService from 'services/Language.service';
import { createSlug } from 'common/utils/utils';

@injectIntl
@observer
export default class JobOfferArticleView extends Component {
  state = {
    jobOffer: null
  };

  currentLanguage = LanguageService.getLang();

  async componentDidMount() {
    await JobOffersStore.fetchPageContent();
    await JobOffersStore.fetchJobOffers();
    await this.getArticle(this.props.match.params.slug);
  }

  async getArticle(slug) {
    const id = +slug.slice(slug.lastIndexOf(',') + 1);
    const jobOffer = JobOffersStore.filterJobOfferById(id);
    if (!jobOffer) {
      const langPrefix = LanguageService.getLangPrefix();
      this.props.history.push(
        `${langPrefix}${ANCHOR.JOBOFFERS[this.currentLanguage]}`
      );
      return;
    }
    const newSlug = createSlug(jobOffer.title, id);
    LanguageService.adjustSlugToLanguage(this, { slug: newSlug });
    this.setState({ jobOffer });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      await this.getArticle(this.props.match.params.slug);
    }
  }

  render() {
    const { jobOffer } = this.state;
    const {
      jobOffers,
      jobOffersPageContent: { bannerImageJobOffer = '', rodoClause = '' } = {}
    } = JobOffersStore;

    if (!jobOffer) {
      return (
        <>
          {ContentStore.isLoaded ? (
            <InjectMetaTags {...ContentStore.content.jobOffersSEO} />
          ) : null}
        </>
      );
    }

    return (
      <div className={styles.JobOfferArticleView}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.jobOffersSEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Container>
          <div className={`${styles.ContainerArticle} `}>
            <Link to={ANCHOR.JOBOFFERS[this.currentLanguage]}>
              <div className={styles.ReturnDiv}>
                <i className={styles.ArrowLeft} />
                <span className={styles.Return}>
                  {this.props.intl.formatMessage(
                    messages.returnToJobOffersList
                  )}
                </span>
              </div>
            </Link>
            <Placeholder
              component={
                <ContentBar
                  className={styles.JobOffersMainContentPlaceholder}
                />
              }
              ready={JobOffersStore.isLoaded()}
            >
              <JobOfferArticle
                article={jobOffer}
                bgPhoto={bannerImageJobOffer}
                rodoClause={rodoClause}
                apply={this.props.intl.formatMessage(messages.apply)}
                traffitFormLink={jobOffer.formUrl}
              />
            </Placeholder>
            <BigBlueBox
              joinOurTeam={this.props.intl.formatMessage(messages.joinOurTeam)}
              apply={this.props.intl.formatMessage(messages.apply)}
              traffitFormLink={jobOffer.formUrl}
              openInNewTab
            />
            <Link to={ANCHOR.JOBOFFERS[this.currentLanguage]}>
              <div className={styles.ReturnDivLast}>
                <i className={styles.ArrowLeft} />
                <span className={styles.Return}>
                  {this.props.intl.formatMessage(
                    messages.returnToJobOffersList
                  )}
                </span>
              </div>
            </Link>
          </div>
          <div className={`${styles.Sidebar}`}>
            <h3 className={styles.SidebarTitle}>
              {this.props.intl.formatMessage(messages.others)}
            </h3>
            <div>
              <Placeholder
                component={
                  <ContentBar className={styles.JobOffersPlaceholder} />
                }
                repeat={6}
                ready={JobOffersStore.isLoaded()}
              >
                <JobOffersList jobOffers={jobOffers} isArticleView />
              </Placeholder>
              <PrimaryButton
                link={EXTERNAL_LINK.CAREER}
                subText={this.props.intl.formatMessage(messages.buttonQuestion)}
                text={this.props.intl.formatMessage(messages.buttonSendCV)}
                className={styles.SendCVButton}
              />
            </div>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/JobOfferArticleView.js